import client, {ConfigWithToken} from './client'
import {ProjectLabSampleType, ProjectType, ProjectUserRolesType, ReportingPeriodType} from 'apm/types';

export const getProject = async (id: any): Promise<ProjectType> => {
    try {
        const {data: response} = await client.get(`projects/${id}`, ConfigWithToken()).then(response => response.data)
        return response;
    } catch (error) {
        return Promise.reject(error);
    }
}
export const getProjectUserRoles = async (id: any): Promise<ProjectUserRolesType> => {
    try {
        const {data: response} = await client.get(`projects/${id}/user-roles`, ConfigWithToken())
        return response;
        // return roles;
    } catch (error) {
        return Promise.reject(error);
    }
}
export const getProjects = async (): Promise<ProjectType[]> => {
    try {
        const {data: response} = await client.get(`projects/all`, ConfigWithToken()).then(response => response.data);
        return response;
    } catch (error) {
        return Promise.reject(error);
    }
}
export const getProjectLabSampleTypes = async (project_id: any): Promise<ProjectLabSampleType[]> => {
    try {
        const {data: response} = await client.get(`projects/${project_id}/lab-sample-types`, ConfigWithToken()).then(response => response.data);
        return response;
    } catch (error) {
        return Promise.reject(error);
    }
}
export const getReportingPeriods = async (project_id: number): Promise<ReportingPeriodType[]> => {
    try {
        const {data: response} = await client.get(`reports/project/${project_id}/reporting-periods`, ConfigWithToken()).then(response => response.data);
        return response;
    } catch (error) {
        return Promise.reject(error);
    }
}